// extracted by mini-css-extract-plugin
export default {"shipmentDetails":"Dy-z","trackingProgress":"Ey-z","steps":"Fy-z","step":"Gy-z","stepComplete":"Hy-z","stepActive":"Iy-z"};